import serviceClient from '../../service-client/service-client';
import pollAsyncJob from '../../../utils/poll-async-job';

const JOB_INTERVAL = 3000;

const addLocale = async ({ siteId, destinationLocale, originLocale, translateOptions }) => {
  const client = serviceClient.get();

  const response = await client.createSiteLocale(siteId, {
    originLocale,
    destinationLocale,
    ...translateOptions,
  });

  const {
    data: { id: jobId },
  } = response;

  return pollAsyncJob(jobId, JOB_INTERVAL);
};

export default addLocale;
